"use client";

import { useEffect } from "react";
import { Open_Sans } from "next/font/google";
import { AppSettingsProvider, ReactQueryClientProvider } from "@/app";
import { ToastContainer } from "react-toastify";

const openSans = Open_Sans({
  subsets: ["latin"],
  weight: ["300", "400", "600", "700"],
  display: "swap",
});

// ssgoi
import { Ssgoi } from "@ssgoi/react";
import { fade } from "@ssgoi/react/view-transitions";

const config = {
  defaultTransition: fade({
    inSpring: {
      //페이지에 들어갈 때 적용됩니다.
      stiffness: 100, // 빠른 트랜지션
      damping: 20, // 부드러운 마무리
    },
    outSpring: {
      //페이지를 떠날 때 적용됩니다.
      stiffness: 100, // 빠른 트랜지션
      damping: 20, // 부드러운 마무리
    },
  }),
};

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  // Service Worker 제거 (캐시된 CSP 문제 해결)
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
          console.log("Service Worker unregistered:", registration);
        });
      });
    }
  }, []);

  return (
    <html lang="ko" className={openSans.className}>
      <head>
        <title>위즈온</title>
        {/* 모든 페이지에 공통으로 적용될 기본 설정 */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, viewport-fit=cover"
        />

        {/* 기본 테마 색상 (흰색) 설정. 페이지에서 동적으로 변경됨 */}
        <meta name="theme-color" content="#ffffff" />
      </head>
      <body className="theme-default">
        <ReactQueryClientProvider>
          <AppSettingsProvider>
            <Ssgoi config={config}>
              {/* <div style={{ position: "relative", minHeight: "100vh" }}> */}
              {children}
              {/* </div> */}
            </Ssgoi>

            <ToastContainer
              autoClose={5000}
              pauseOnFocusLoss={false}
              pauseOnHover={false}
            />
          </AppSettingsProvider>
        </ReactQueryClientProvider>
      </body>
    </html>
  );
}
